// Import the functions you need from the SDKs you need
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAsNiRMTgGCLJx552pQDQ5xan1TqGjx5hs",
  authDomain: "haircare-ai.firebaseapp.com",
  projectId: "haircare-ai",
  storageBucket: "haircare-ai.appspot.com",
  messagingSenderId: "222386231420",
  appId: "1:222386231420:web:d6e7afdceb0da9eb7c51f9",
  measurementId: "G-PSWQ632PZD",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
